import ModelEntity from "../../model2/model-entity"
import FieldProto from "../proto/field-proto"
import {EntityType} from "../../gd/const/item"
import Project from "../../model2/project/project";

export enum ColorPalette {
    CORE        = 'core',   // project , etc.
    STATUS      = 'status',
    PRIORITY    = 'priority',
    SYSTEM      = 'system',   // closed ? / RAG
    GRAY        = 'gray',
}

export enum DefaultPaletteColorNumber {
    CORE        = 20,
    STATUS      = 12,
    PRIORITY    = 5,
    SYSTEM      = 1,   // closed ? / RAG
    GRAY        = 1,
}

export enum PaletteContrast {
    DEFAULT         = 'base',
    LIGHT           = 'light',
    PALE            = 'pale',
    PALEBG          = 'palebg',
}

export type ItemColorCoding = {
    colorNumber     : number,           // color number
    corePalette     : ColorPalette,
    contrast?       : PaletteContrast   // good one module seeting can set it (caledar case)
}

const debug = false
// const debug = "ColorCodingHelper"

export function getItemColorCoding(model: ModelEntity, fieldId: ID): ItemColorCoding {

    let field: FieldProto | null = null

    if (fieldId) {
        switch (model.entityType) {
            case EntityType.TASK    :
                field = gd.fields.task.get(fieldId)
                break

            case EntityType.PROJECT :
                if (fieldId === 'statusId' && (model as Project).isFolder) fieldId = 'systemStatus'
                field = gd.fields.project.get(fieldId)
                break

            case EntityType.EVENT   :
                field = gd.fields.event.get(fieldId)
                break
        }
    }

    let itemColorCoding
    if (field && field.fieldId) {
        itemColorCoding = field.getColorCoding(model)
    } else {
        switch (model.entityType) {
            case EntityType.PROJECT :
                itemColorCoding = {
                    colorNumber: 9,
                    corePalette: ColorPalette.GRAY
                }
                break

            case EntityType.TASK    :
            case EntityType.EVENT   :
            default                 :
                itemColorCoding = {
                    colorNumber: 1,
                    corePalette: ColorPalette.SYSTEM
                }
                break
        }
    }

    debug && console.log(debug, 'getItemColorCoding', itemColorCoding, field, model)

    return itemColorCoding
}

// export function styleArrow(itemColorCoding) {
//     return {
//         borderLeft: getColor()
//     }
// }

// Gantt item render
// itemColorCoding(model, settings)
//
//     if model.isClosed {
//         return colorCodingClosed
//     }


// Model
//
// colorCoding {
//     Core palette
//     Contrast Palette
//     Number
// }
//
// Settings
//
// EntityType -> (Field, Contrast)
//
// ItemRender
//
// model, moduleSettings - colorCoding
